
export default function SQLs_Not() {
  return (
    <div>
      <h1>SQL Not</h1>
      <p>Content for SQL Not will go here.</p>
    </div>
  );
}
